import type { LegalDoc } from './types'
import { fillPortal } from './types'

/** Renders a legal document: intro paragraphs, then sections, then simple body. */
export function LegalDocBody({
  doc,
  portal,
  entity = 'GameCodex',
}: {
  doc: LegalDoc
  portal: string
  entity?: string
}) {
  const fill = (t: string) => fillPortal(t, portal, entity)
  const simple = doc.body ? (Array.isArray(doc.body) ? doc.body : [doc.body]) : []

  return (
    <article className="legal-doc">
      <h1>{doc.title}</h1>
      {doc.updated && <p className="legal-updated">Last updated {doc.updated}</p>}

      {doc.intro?.map((p, i) => (
        <p key={`i${i}`}>{fill(p)}</p>
      ))}

      {doc.sections?.map((s, i) => (
        <section key={`s${i}`}>
          {s.heading && <h2>{s.heading}</h2>}
          {s.body.map((p, j) => (
            <p key={j}>{fill(p)}</p>
          ))}
        </section>
      ))}

      {simple.map((p, i) => (
        <p key={`b${i}`}>{fill(p)}</p>
      ))}
    </article>
  )
}

export default LegalDocBody
